import React, {FC} from 'react';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'constants/flow/flowTypes';

import {formatPrice} from 'libs/convertPrice/formatPrice';
import {logWithSentry} from 'libs/sentry/sentry';

type PropsType = {
    currency: string;
};

/**
 * Price formatter which get currency from store
 * @param {PropsType} props - component props
 * @returns {React.ReactElement} - formatted price
 */
const PriceComponent: FC<PropsType> = ({children, currency}) => {
    try {
        return <>{formatPrice(currency, String(children))}</>;
    } catch (err) {
        logWithSentry(err, `PriceComponent: Failed to format the price: ${String(children)}`);
        return null;
    }
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    currency: store.customer.currency.symbol,
});

export const Price = connect(mapStateToProps)(PriceComponent);
